import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { FormFields } from '../../AccountForm.meta';
import { useYearAgeOptionsWithRightLabel } from '../ContributionStartYearSelect/useYearAgeOptionsWithRightLabel';

export const AnnuitizationYear = () => {
  const { control, setValue, watch } = useFormContext<FormFields>();

  const [annuitizationStartAtRetirement, annuityIsAlreadyAnnuitized] = watch([
    'bankAccount.AnnuitizationStartAtRetirement',
    'bankAccount.AnnuityIsAlreadyAnnuitized',
  ]);

  const {
    options: { AnnuityYearOptions },
  } = useAccountFormContext();

  const none = { label: 'None', value: -1 };
  const alreadyAnnuitized = { label: 'Already Annuitized', value: 0 };
  const atRetirement = { label: 'At Retirement', value: 1 };

  const annuityYearOptions = [
    none,
    alreadyAnnuitized,
    atRetirement,
    ...AnnuityYearOptions.map(yearOption => ({
      label: yearOption.toString(),
      value: yearOption,
    })),
  ];

  const options = useYearAgeOptionsWithRightLabel({ options: annuityYearOptions });

  return (
    <>
      <Controller
        control={control}
        name="bankAccount.AnnuitizationStartYear"
        render={({ field: { value, ...field } }) => {
          return (
            <Select
              {...field}
              isPortal
              label="Annuitization Year"
              options={options}
              value={options.find(option => {
                if (annuitizationStartAtRetirement) {
                  return option.value === atRetirement.value;
                }

                if (annuityIsAlreadyAnnuitized) {
                  return option.value === alreadyAnnuitized.value;
                }

                if (value === null) {
                  return option.value === none.value;
                }

                return option.value === value;
              })}
              onChange={opt => {
                switch (opt?.value) {
                  case -1: {
                    setValue('bankAccount.AnnuityIsAnnuitized', false);
                    setValue('bankAccount.AnnuityIsAlreadyAnnuitized', false);
                    setValue('bankAccount.AnnuitizationStartYear', null);
                    setValue('bankAccount.AnnuitizationStartAtRetirement', false);
                    break;
                  }

                  case 0: {
                    setValue('bankAccount.AnnuityIsAnnuitized', true);
                    setValue('bankAccount.AnnuityIsAlreadyAnnuitized', true);
                    setValue('bankAccount.AnnuitizationStartYear', new Date().getFullYear());
                    setValue('bankAccount.AnnuitizationStartAtRetirement', false);
                    break;
                  }

                  case 1: {
                    setValue('bankAccount.AnnuityIsAnnuitized', false);
                    setValue('bankAccount.AnnuityIsAlreadyAnnuitized', false);
                    setValue('bankAccount.AnnuitizationStartYear', null);
                    setValue('bankAccount.AnnuitizationStartAtRetirement', true);
                    break;
                  }

                  default: {
                    setValue('bankAccount.AnnuityIsAnnuitized', true);
                    setValue('bankAccount.AnnuityIsAlreadyAnnuitized', false);
                    setValue('bankAccount.AnnuitizationStartYear', opt?.value || null);
                    setValue('bankAccount.AnnuitizationStartAtRetirement', false);
                  }
                }
              }}
            />
          );
        }}
      />
    </>
  );
};
